// The Pixel base code fires the first PageView (and pricing ViewContent) on
// load. plugins/cookie-consent.client.ts sets fbq.disablePushState on the
// inline snippet, so fbevents.js no longer auto-tracks pushState/replaceState
// navigations — this plugin is the only source of PageViews for later
// client-side route changes (spec §4.3). It calls pageView() (fbq trackSingle)
// rather than track('PageView'): fbevents deduplicates a plain PageView per
// pixel after the first one, so a second `track('PageView')` is silently
// dropped — trackSingle is not deduplicated.
import { isPricingPath } from '~/utils/tracking/metaEvents';

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const { track, pageView } = useMetaPixel();
  let initialNavigation = true;

  router.afterEach((to, from, failure) => {
    if (initialNavigation) {
      initialNavigation = false;
      return;
    }
    if (failure) return;
    if (to.path === from.path) return;
    pageView();
    if (isPricingPath(to.path)) track('ViewContent', { content_name: 'pricing' });
  });
});
